<script>
    import { appProfileState } from "../../state/ApplicationState.svelte";
    import { Button } from "@sveltestrap/sveltestrap";
    import BankAccountEditor from "./BankAccountEditor.svelte";
    import BankAccountCard from "./BankAccountCard.svelte";
    import { Loader } from "../../../../../SharedSvelte/GlobalLoader.svelte";
    import { baseUrl } from "../../../../../SharedSvelte/Common.svelte";
    import Dialog from "../../../../../SharedSvelte/Dialog.svelte";

    let prompt;
    let apiPromise = $state(fetchBankAccountContent()); 

    function handleAddClick(event) {
        event.preventDefault();
        appProfileState.workingBankAccount = { memberId: appProfileState.memberDetails?.memberId };
        appProfileState.showBankAccountEditor = true;
        window.scrollTo(0, 0);
    }

    function onDeleteHandler(data){
        prompt.dialog(
			"Are you sure you want to delete this account?",
			"Please Confirm",
			function () {
				(async () => {
                    //console.debug("delete", data.id)
					await deleteBankAccount(data.id);
				})();
			},
		);
    }

    function onEditClickHandler(data){
        let workingBankAccount = appProfileState.bankAccounts.find(a => a.id === data.id);
        if (workingBankAccount){
            appProfileState.workingBankAccount = workingBankAccount;
            appProfileState.showBankAccountEditor = true;
            window.scrollTo(0, 0);
        }
    }

    async function deleteBankAccount(id) {
		Loader.display();
        //console.log("deleteBankAccount", id)
		try {
			const response = await fetch(`${baseUrl}Options/Profile/DeleteBankAccount`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					__RequestVerificationToken: document.getElementsByName("__RequestVerificationToken",)[0].value,
				},
                body: id
				//body: JSON.stringify({id})
			});
			if (!response.ok) {
				const error = `Server exception: ${response.status} ${response.statusText}`;
				//console.log(error);
				throw new Error();
			}

			const json = await response.json();
			if (!json.success) {
				//console.log(json.errors);
				throw new Error(json.errors);
			} 
            
            //console.log(json.bankAccounts)
            appProfileState.bankAccounts = json.bankAccounts;
		    prompt.showMessage("Your request has been received. Please allow 15 minutes to see your changes.", "Success");
			
		} catch (err) {
			saveError = "Failed to delete account information. ";
			prompt.showMessage(saveError, "Error");
		} finally {
			Loader.hide();
		}
	}

    async function fetchBankAccountContent() {
        Loader.display();
        
        appProfileState.showBankAccountEditor = false;
        appProfileState.workingBankAccount = null;
        window.scrollTo(0, 0);

        try {
            const response = await fetch(`${baseUrl}Options/Profile/BankAccountsContent`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    '__RequestVerificationToken': document.getElementsByName("__RequestVerificationToken")[0].value
                },
                // body: JSON.stringify({
                //     id
                // })
            });

            if (!response.ok) {
                const error = `Server exception: ${response.status} ${response.statusText}`;
                prompt.showMessage(error, "Information");
                throw new Error(error);
            }

            const data = await response.json();
            appProfileState.bankAccounts = data.bankAccounts;

            return data; // Resolves the Promise with the fetched data
        } catch (error) {
            console.error("Error fetching bank accounts content:", error);
            return Promise.reject(error); // Rejects the Promise with the error
        } finally {
            Loader.hide();
        }
    }
    
</script>
{#if appProfileState.showBankAccountEditor }
    <BankAccountEditor />
{:else}
    <main>
        <h1 class="mt-3 mb-3 ms-3">Financial Institutions</h1>
        {#await apiPromise}
            <div>Loading...</div>
        {:then data}
            <!-- <pre>{JSON.stringify(data)}</pre> -->
            <div class="p-3 border rounded bg-light mb-3">
                <p>
                    You can set up automatic premium payments and receive direct deposits by linking your profile with your financial institution. 
                </p>
                This allows you to manage your payments and deposits securely and conveniently, 
                helping ensure your coverage remains active without interruption.
            </div>
            <div class="row">
                {#each appProfileState.bankAccounts as bankAccount}
                    <div class="mb-3 col-lg-6 col-md-12 col-sm-12 col-xs-12">
                        <BankAccountCard 
                            id={bankAccount.id}
                            usageType={bankAccount.usageType}
                            bankName={bankAccount.bankName}
                            routingNumber={bankAccount.routingNumber}
                            accountType={bankAccount.accountType}
                            accountNumber={bankAccount.accountNumber}
                            hasPendingChanges={bankAccount.hasPendingChanges}
                            oneditcallback={onEditClickHandler}
                            ondeletecallback={onDeleteHandler}
                        />
                    </div>
                {/each}
            </div>
            <div class="row mb-3">
                <div class="col">
                <Button color="primary btn-lg" onclick={handleAddClick}>Add Account</Button>
                </div>
            </div>
            
        <!-- {:catch error}
            <div class="text-danger">{error}</div> -->
        {/await}

    
    </main>
{/if}

<Dialog bind:this={prompt} />